import ModuleContent from "features/shared/layout/content/ModuleContent";
import Header from "features/shared/layout/header/Header";
import React from "react";
import { useTranslation } from "react-i18next";
import ContractingPrepareFormSection from "features/contracting/sections/prepareForm/ContractingPrepareFormSection";
import { Commodity } from "features/shared/enums/commodity";
import { useParams } from "react-router-dom";

type RouteProps = {
  commodity: Commodity;
};

const ContractingPreparePage = () => {
  // translations
  const tLabels = useTranslation("shared\\moduleNames").t;

  // router
  const { commodity } = useParams<RouteProps>();

  // render
  return (
    <>
      <Header
        title={tLabels("contractingPreparePage.title")}
        includeBreadcrumbs
        links={[{ to: "/contracting", text: tLabels("contracting.title") }]}
      />
      <ModuleContent>
        <ContractingPrepareFormSection commodity={commodity} />
      </ModuleContent>
    </>
  );
};

export default ContractingPreparePage;
